import { render, staticRenderFns } from "./FormCessaoDireitos.vue?vue&type=template&id=5198df51&"
import script from "./FormCessaoDireitos.vue?vue&type=script&lang=js&"
export * from "./FormCessaoDireitos.vue?vue&type=script&lang=js&"
import style0 from "./FormCessaoDireitos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports